export default {"name":"NovaComponents-RadioButtonGroup-gui-icu","comments":[],"messages":{"NovaComponents-RadioButtonGroup-gui-icu.readOnly.aria":"read only"}}